import { store, getContext } from '@wordpress/interactivity';

import { decode } from 'he';

/**
 * Adds timeline-specific interactivity to the store.
 */
store('mediapress-live', {
  state: {
    get entryHrefAttr() {
      const context = getContext();
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      params.delete('live-feed-page');
      params.set('live-feed-entry-id', context?.entry?.id || '');

      return `?${params.toString()}`;
    },
    get title() {
      const context = getContext();
      return decode(context?.entry?.title.rendered || '');
    },
  },
  actions: {
    *navigateToFeedEntry(e) {
      e.preventDefault();

      const href = e.target.getAttribute('href');
      const entryId = new URLSearchParams(href).get('live-feed-entry-id');

      const element = document.getElementById(`live-feed-entry-id-${entryId}`);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        window.history.pushState({}, '', href);
        return;
      }

      const { actions: router } = yield import('@wordpress/interactivity-router');

      yield router.navigate(href, { force: true });
    },
  },
});
